























import '../styles/category-tile.css'
import Vue from 'vue'
import { CIcon } from '@coreui/icons-vue'
import { cisStar, cilStar } from '@coreui/icons-pro'

export default Vue.extend({
  data() {
    return {
      favoritedStarIcon: cisStar,
      standardStarIcon: cilStar,
    }
  },
  components: { CIcon },
  props: {
    title: {
      type: String,
      required: true,
    },
    imageUrl: {
      type: String,
      required: false,
    },
    favorite: {
      type: Boolean,
      required: false,
    },
  },
  name: 'CategoryLink',
})
